import FigmaBadge from '../../../Elements/FigmaBadge';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import JsxHelper from '../../../Helpers/JsxHelper';
import TpJobItem from './TpJobItem';
import React from 'react';

export default class TpEvaluatorRelatedTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        minWidth: 50,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        label: 'Client',
        orderById: 'CaspianClientDetails',
        data: (item) => TpJobItem.getClientDetails(item),
        minWidth: 50,
      },
      {
        label: 'Project',
        orderById: 'ProjectNameAndId',
        data: TpJobItem.getProjectCellContent,
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Client Invoice ID',
        orderById: 'TpClientInvoiceId',
        data: 'TpClientInvoiceId',
        minWidth: 50,
      },
      {
        label: 'Fee Total',
        orderById: 'EvalFeeTotal',
        data: 'EvalFeeTotal',
        minWidth: 50,
      },
      {
        label: 'Reimb Total',
        orderById: 'EvalReimbursementTotal',
        data: 'EvalReimbursementTotal',
        minWidth: 50,
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellWarningContent,
        minWidth: 50,
      },
      {
        label: 'PS',
        orderById: 'PayEvaluator',
        data: (item) => TpEvaluatorRelatedTpJobItem.badgeFunction(item.PayEvaluator),
        minWidth: 50,
      },
      {
        label: 'BC',
        orderById: 'BillClient',
        data: (item) => TpEvaluatorRelatedTpJobItem.badgeFunction(item.BillClient),
        minWidth: 50,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
    ];
  }

  static badgeFunction(item) {
    return (
      <FigmaBadge
        Active={item}
        ActiveText='Yes'
        InactiveText='No'
        width={50}
      />
    );
  }
}
